import React from 'react';
import { LazyLoadContainer } from '@web-for-marketing/react-ui';
import RenderedCKEditorArticle from './RenderedCKEditorArticle';
import { Grid } from '@mui/material';

interface RenderedArticleProps {
    content: string;
    mediaUrlPrefix: string;
}

export function RenderedArticle({ content, mediaUrlPrefix }: RenderedArticleProps): React.ReactElement {
    return (
        <LazyLoadContainer component={Grid}>
            <RenderedCKEditorArticle content={content} mediaUrlPrefix={mediaUrlPrefix} />
        </LazyLoadContainer>
    );
}
